import request from '@/api/request.js'

// 新增
export function SystemLetterInsert(data) {
    return request({
        url: '/api/letter/systemletterinsert',
        method: 'post',
        data: data
    })
}

// 删除
export function SystemLetterDelete(id) {
    return request({
        url: `/api/letter/systemletterdelete/${id}`,
        method: 'post',
        data: {}
    })
}

// 更新
export function SystemLetterUpdate(id, data) {
    return request({
        url: `/api/letter/systemletterupdate/${id}`,
        method: 'post',
        data: data
    })
}

// 获取
export function SystemLetterGetById(id) {
    return request({
        url: `/api/letter/getsystemletterbyid/${id}`,
        method: 'get',
        data: {}
    })
}

// 获取列表
export function SystemLetterGetList(params) {
    return request({
        url: '/api/letter/getsystemletterlist',
        method: 'get',
        params: params
    })
}

// 获取分页列表
export function SystemLetterGetPageList(params) {
    return request({
        url: '/api/letter/getsystemletterpagelist',
        method: 'get',
        params: params
    })
}